import { render } from "./officialAccountsData.vue?vue&type=template&id=30966e30&scoped=true"
import script from "./officialAccountsData.vue?vue&type=script&lang=js"
export * from "./officialAccountsData.vue?vue&type=script&lang=js"

import "./officialAccountsData.vue?vue&type=style&index=0&id=30966e30&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "E:\\aliPro\\platformpro\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30966e30"]])

export default __exports__